import { useContext } from 'react';

import BuildingFilterContext, { BuildingFilterContextValues } from './context';

const useBuildingFilter = (): BuildingFilterContextValues => useContext(BuildingFilterContext);

export default useBuildingFilter;
